import type { SVGProps } from "react";
export interface WatermelonIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WatermelonIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WatermelonIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 9.67c0-2.072-.574-4.085-1.634-5.826l-.218-.344a.81.81 0 0 0-.684-.375 1.25 1.25 0 0 0-.813.29l-.105.095L3.51 17.42a1.27 1.27 0 0 0-.386.919.81.81 0 0 0 .375.684l.344.218a11.205 11.205 0 0 0 13.75-1.648l.382-.402a11.2 11.2 0 0 0 2.899-7.521Zm2.25 0a13.456 13.456 0 0 1-20.45 11.493l-.414-.262C.383 19.661.562 17.187 1.92 15.83L15.83 1.92l.266-.24C17.491.547 19.74.5 20.901 2.26l.262.415a13.46 13.46 0 0 1 1.962 6.995"
      />
      <path
        fill={color}
        d="M17.793 9.67a8.12 8.12 0 0 0-1.64-4.893L4.777 16.152A8.121 8.121 0 0 0 17.793 9.67M8.55 14.094a1.375 1.375 0 1 1-1.507 1.509l-.008-.141.008-.14a1.375 1.375 0 0 1 1.366-1.236zm3.803-.605a1.375 1.375 0 1 1-1.509 1.509l-.007-.141.007-.14a1.376 1.376 0 0 1 1.368-1.236zm2.644-2.644a1.376 1.376 0 1 1-1.509 1.509l-.007-.141.007-.14a1.375 1.375 0 0 1 1.368-1.236zm.605-3.803a1.376 1.376 0 1 1-1.509 1.509l-.007-.14.007-.141a1.375 1.375 0 0 1 1.368-1.234zm4.44 2.628a10.373 10.373 0 0 1-17.707 7.334 1.125 1.125 0 0 1 0-1.59L15.414 2.335l.171-.14a1.125 1.125 0 0 1 1.42.14 10.37 10.37 0 0 1 3.038 7.335Z"
      />
    </svg>
  );
}
